import { render, staticRenderFns } from "./AliPlayer.vue?vue&type=template&id=0337576a&scoped=true&"
import script from "./AliPlayer.vue?vue&type=script&lang=js&"
export * from "./AliPlayer.vue?vue&type=script&lang=js&"
import style1 from "./AliPlayer.vue?vue&type=style&index=1&id=0337576a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0337576a",
  null
  
)

export default component.exports